import { Theme } from "./types";

export const THEME: Theme = {
    id: "mipa",
};